<template>
    <v-form ref="buildingUserForm" :value="isFormValid"  lazy-validation>
     <v-card >
        <v-card-title>
            Single Building Management Contact Replacement
        </v-card-title>
        <v-card-text class="d-inline-flex">
            <v-row>
                <v-col cols="3">
                    <v-select  :items="buildings" v-model="userChanging.building" label="Building" :return-object="true"
                        @change="onBuildingChange" :rules="[v=>!!v || 'Building is required']" required>
                        <template #label>Building <span class="red--text"><strong>*</strong></span></template>
                    </v-select>
                </v-col>
                <v-col cols="3">
                    <v-combobox  :items="usersBuilding" 
                            v-model="userChanging.currentUsers" 
                            label ="Current User" :return-object="true" 
                            :rules="[v=>!!v || 'Current User is required']" required 
                            multiple
                            :readonly=true>
                        <template #label>Current Management Contact <span class="red--text"> <strong>*</strong> </span></template>
                    </v-combobox>
                </v-col>
                <v-col cols="3">
                    <!--multiple hide-selected-->
                    <v-dialog v-model="isNewUserDialogVisible" persistent >
                            <NewUser :userName="newUserName" @saved="newUserAdded" @canceled="newUserCancel"></NewUser>
                    </v-dialog>
                    <v-combobox  :items="userList" v-model="userChanging.newUsers" label="New Users" 
                        :rules="[v=>!!v || 'New user is required']" required 
                        @change="onUserChange" multiple>
                        <template #label> New Management Contact <span class="red--text"> <strong>*</strong> </span></template>
                    </v-combobox>         
                </v-col>
                <v-col cols="2">
                    <!--
                        <v-tooltip bottom>
                        <template v-slot:activator="{on,attrs}">
                            <a class="ma-2" target="_blank" @click="onAddingNewUser" >
                                <v-icon v-bind="attrs" v-on="on" color="primary">mdi-account-plus</v-icon>
                            </a>
                        </template>
                        <span>Add a new user</span>
                    </v-tooltip>
                    -->
                    
                    <v-btn  dark color="success ma-2" @click="onUpdatingUser" >
                        <v-icon>mdi-content-save</v-icon>
                        Update User 

                    </v-btn>
                    <ConfirmationPanel :isVisible="isConfirmVisible" :message="confirmMessage" @confirm:click="onUpdateUserConfirm"></ConfirmationPanel>      
                </v-col>
            </v-row>      
        </v-card-text>        
     </v-card>
    </v-form>
</template>
<script>
    import radiationAPI from '@/services/radiationservice';
    import userAPI from '@/services/userservice';

    export default{
        name:'UserBuildingReplacement',
        data:function(){
            return {
                buildings:[],
                usersBuilding: [],
                userList:[],
                isFormValid:false,
                isConfirmVisible:false,
                confirmMessage:'',
                userChanging:{
                    building:'',
                    currentUsers:[],
                    newUsers:[],
                },
                newUserName:'',
                isNewUserDialogVisible:false
            }
        },
        methods:{
            onBuildingChange: async function(building)
            {
                console.log(building.value);
                await userAPI.getUsersByBuilding(building.value)
                .then(response=>{
                    this.usersBuilding=response.data;
                    this.userChanging.currentUsers=this.usersBuilding;
                })
            },
            onUpdatingUser: async function(){
                this.isFormValid=this.$refs.buildingUserForm.validate();
                if(this.userChanging.newUsers.length<1)
                {
                    this.$emit('UserBuildingReplacement:click',false,"New User(s) must be selected");
                    return;
                }
                if(this.isFormValid)
                {
                    this.confirmMessage='Confirm Single Building User Replacement';
                    this.isConfirmVisible=true;
                }
            },
            onUpdateUserConfirm:async function(value){
                this.isConfirmVisible=false;
                if(value)
                    this.onUpdateUser(); 
            },
            onUpdateUser: async function(){
                console.log('On update USer');
                const users=[];
                this.userChanging.newUsers.map((newUser)=>{
                    users.push(newUser.value);
                });
                const model={
                    buildingCode: this.userChanging.building.value,
                    currentUser:'',
                    newUsers:users
                };
                console.log('Model', model);
                await userAPI.updateBuildingUser(model)
                .then(response=>{
                    console.log(response);
                    if(response.status===200)
                    {
                        this.$emit('UserBuildingReplacement:click',
                                    true,
                                    `Users have been successfully replaced at buildng ${response.data.buildingCode}.`);
                    } else{
                        this.$emit('UserBuildingReplacement:click',false,"User change has failed");
                    }
                })
                .catch(error=>{console.log(error)});
            },
            async onAddingNewUser(){
                this.isNewUserDialogVisible=true;
            },
            async onUserChange(dropBox){
                if(typeof(dropBox)==='string' && dropBox.trim())
                {   
                    var value=dropBox;
                    console.log('value', dropBox);
                    this.newUserName=value;
                    const item=this.userList.find(user=>user.value===value);
                    if(item){
                        this.userChanging.newUsers={value:item.value, text: item.text };     
                    } else{ 
                        this.isNewUserDialogVisible=true;   
                    }
                }   
            },
            async newUserAdded(isSaved,message, newUser){
                console.log('Message',message);
                if(isSaved)
                {
                  await this.loadUsers();
                  this.user={value: newUser.userId, text: newUser.name};
                }
                this.isNewUserDialogVisible=false;
            },
            async newUserCancel(value){
                this.isNewUserDialogVisible=value;
            },
            async loadBuildings(){
                await radiationAPI.getAllBuildings()
                .then(response=>{
                    response.data.map((building)=>{
                    this.buildings.push({value:building.code, text: building.code+' - '+building.description})
                });
                })
                .catch(error=>{console.log(error)});
            },
            async loadUsers(){
                await userAPI.getUsers()
                .then(response=>{
                    response.data.map((user)=>{
                        this.userList.push({value:user.userId, text: user.name});
                    });
                })
                .catch(error=>{console.log(error)});
            }

        },
        mounted:async function(){
            await this.loadBuildings();
            await this.loadUsers();
            
        },
        components:{
            NewUser: ()=>import('./NewUser'),
            ConfirmationPanel:()=>import('@/views/commond/ConfirmationPanel')
        }
    }
</script>